/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateWirePaymentFeeDto } from '../models/CalculateWirePaymentFeeDto';
import type { CreateWireTransferDto } from '../models/CreateWireTransferDto';
import type { DepositMethod } from '../models/DepositMethod';
import type { DepositSource } from '../models/DepositSource';
import type { PaymentConfigurationDto } from '../models/PaymentConfigurationDto';
import type { PaymentMethodsDto } from '../models/PaymentMethodsDto';
import type { WireTransferBankAccountDto } from '../models/WireTransferBankAccountDto';
import type { WireTransferDto } from '../models/WireTransferDto';
import type { WireTransferFeeDto } from '../models/WireTransferFeeDto';
import type { WireTransferRecentBankDetailsDto } from '../models/WireTransferRecentBankDetailsDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class DepositService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * @param currency
     * @returns PaymentConfigurationDto Success
     * @throws ApiError
     */
    public getApiDepositsPaymentTypes(
        currency?: string,
    ): CancelablePromise<PaymentConfigurationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits/payment-types',
            query: {
                'currency': currency,
            },
            errors: {
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param currency
     * @returns PaymentMethodsDto Success
     * @throws ApiError
     */
    public getApiDepositsPaymentMethods(
        currency?: string,
    ): CancelablePromise<PaymentMethodsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits/payment-methods',
            query: {
                'currency': currency,
            },
            errors: {
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param customerId
     * @param paymentType
     * @returns void
     * @throws ApiError
     */
    public getApiDeposits(
        customerId?: string,
        paymentType?: DepositMethod,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits',
            query: {
                'customerId': customerId,
                'paymentType': paymentType,
            },
            errors: {
                302: `Redirect`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param paymentType
     * @param deviceSource
     * @returns string Success
     * @throws ApiError
     */
    public getApiDepositsUrl(
        paymentType: DepositMethod,
        deviceSource?: DepositSource,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits/url',
            query: {
                'paymentType': paymentType,
                'deviceSource': deviceSource,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param countryIso2
     * @param currency
     * @returns WireTransferBankAccountDto Success
     * @throws ApiError
     */
    public getApiDepositsWireTransferBankAccounts(
        countryIso2: string,
        currency: string,
    ): CancelablePromise<Array<WireTransferBankAccountDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits/wire-transfer/bank-accounts',
            query: {
                'countryIso2': countryIso2,
                'currency': currency,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WireTransferFeeDto Success
     * @throws ApiError
     */
    public postApiDepositsWireTransferFee(
        requestBody?: CalculateWirePaymentFeeDto,
    ): CancelablePromise<WireTransferFeeDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/deposits/wire-transfer/fee',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WireTransferDto Created
     * @throws ApiError
     */
    public postApiDepositsWireTransfer(
        requestBody?: CreateWireTransferDto,
    ): CancelablePromise<WireTransferDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/deposits/wire-transfer',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param currency
     * @returns WireTransferRecentBankDetailsDto Success
     * @throws ApiError
     */
    public getApiDepositsWireTransferRecentBankDetails(
        currency?: string,
    ): CancelablePromise<WireTransferRecentBankDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deposits/wire-transfer/recent-bank-details',
            query: {
                'currency': currency,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
